import http from '@/utils/http';

export const teamLineup = (parameter) => {
  return http.request({
    url: '/v1/sports/team/lineup',
    method: 'get',
    params: parameter
  })
}